<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M20.7119 4.79932C21.2819 4.79932 21.7119 5.29932 21.4819 6.22932L18.6919 19.3793C18.4969 20.3143 17.9319 20.5393 17.1519 20.1043L10.4969 15.1893C10.4711 15.1708 10.45 15.1464 10.4355 15.1181C10.421 15.0899 10.4135 15.0586 10.4135 15.0268C10.4135 14.9951 10.421 14.9637 10.4355 14.9355C10.45 14.9072 10.4711 14.8828 10.4969 14.8643L18.1819 7.92432C18.5319 7.61432 18.1069 7.46432 17.6469 7.74432L8.00186 13.8293C7.97261 13.8484 7.9394 13.8606 7.90474 13.8649C7.87009 13.8692 7.83491 13.8656 7.80186 13.8543L3.70686 12.5593C2.79686 12.2943 2.79686 11.6693 3.91186 11.2243L20.2969 4.90432C20.4268 4.84198 20.5679 4.80628 20.7119 4.79932Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>